<template>
  <div>
    <!-- SideBar For staff departments -->
    <b-sidebar
      id="sidebar-right"
      ref="mySidebar"
      bg-variant="white"
      v-model="visibility"
      sidebar-class="sidebar-lg"
      right
      no-header
      backdrop
      shadow
    >
      <div
        class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1"
      >
        <h5 class="mb-0">
          {{ $t(sidebarTitle) }}
        </h5>
        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="hideSideBar()"
        />
      </div>
      <b-form class="p-2" @submit.prevent>
        <b-row class="mt-1">
          <b-col md="12">
            <b-form-group
              :label="$t('Department') + ' *'"
              :invalid-feedback="$t('Department name is required')"
              ref="department"
            >
              <b-form-input
                ref="name"
                :placeholder="$t('Enter department name')"
                v-model="myObj.name"
              />
            </b-form-group>
          </b-col>

          <b-col md="12">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              type="submit"
              variant="success"
              @click="Add()"
              :disabled="request"
              block
            >
              <b-spinner v-if="request" small type="grow" />
              <span v-else> {{ $t(sidebarButton) }} </span>
            </b-button>
          </b-col>
        </b-row>
      </b-form>
      <sidebar-content />
    </b-sidebar>

    <b-sidebar
      id="sidebar-timing"
      bg-variant="white"
      v-model="visibility2"
      sidebar-class="sidebar-lg"
      right
      no-header
      backdrop
      shadow
      width="500px"
    >
      <div
        class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1"
      >
        <h5 class="mb-0">
          {{ currentDep ? currentDep.name : $t("Department") }}
          {{ $t("Timings") }}
          <b-form-checkbox
            class="mr-0 ml-1"
            v-model="sameDays"
            switch
            inline
            v-b-tooltip.hover.bottomright
            :title="$t('Everyday schedule same as monday')"
            @input="setDays(timingInfo[0])"
          />
        </h5>
        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="visibility2 = false"
        />
      </div>
      <b-form class="px-1 py-2" @submit.prevent>
        <b-row v-for="(item, index) in timingInfo" :key="index">
          <b-col md="4" class="pr-md-0">
            <b-form-group :invalid-feedback="$t('Day is required')" ref="day">
              <div
                class="d-flex align-items-center justify-content-between pb-50"
              >
                <label class="bv-no-focus-ring col-form-label p-0"
                  >{{ $t("Day") }}
                </label>
                <b-form-checkbox
                  v-model="item.dayOff"
                  switch
                  inline
                  v-b-tooltip.hover.bottomright
                  :title="$t('Day Off')"
                  class="custom-control-danger mr-0 ml-1"
                />
              </div>
              <v-select
                v-model="item.day"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="daysList"
                :reduce="(op) => op.value"
                :selectable="(opt) => !currDays.includes(opt.value)"
                :clearable="false"
                label="text"
                @input="changeDay()"
              />
            </b-form-group>
          </b-col>
          <b-col md="3" class="pr-md-0">
            <b-form-group
              :label="$t('Joins at')"
              :invalid-feedback="$t('Joins at is required')"
              ref="join"
            >
              <flat-pickr
                v-model="item.timeIn"
                class="form-control"
                :config="{
                  enableTime: true,
                  noCalendar: true,
                  altFormat: 'h:i K',
                  altInput: true,
                  dateFormat: 'Y-m-d\\TH:i:S',
                  defaultHour: 8,
                }"
                :disabled="item.dayOff"
              />
            </b-form-group>
          </b-col>
          <b-col md="3" class="pr-md-0">
            <b-form-group
              :label="$t('Leaves at')"
              :invalid-feedback="$t('Leaves at is required')"
              ref="leave"
            >
              <flat-pickr
                v-model="item.timeOut"
                class="form-control"
                :config="{
                  enableTime: true,
                  noCalendar: true,
                  altFormat: 'h:i K',
                  altInput: true,
                  dateFormat: 'Y-m-d\\TH:i:S',
                  defaultHour: 13,
                }"
                :disabled="item.dayOff"
                @on-close="setDays(item)"
              />
            </b-form-group>
          </b-col>

          <b-col md="2" class="pr-md-0 align-self-center">
            <feather-icon
              v-if="index == timingInfo.length - 1"
              icon="PlusIcon"
              size="16"
              class="cursor-pointer ml-50"
              @click="addDay()"
            />
            <feather-icon
              v-if="timingInfo.length > 1"
              icon="TrashIcon"
              size="16"
              class="cursor-pointer ml-50"
              @click="removeDay(item, index)"
            />
          </b-col>
        </b-row>
        <b-row class="mt-2">
          <b-col md="12">
            <b-button
              variant="success"
              @click="saveTimings()"
              :disabled="savingTime"
              block
            >
              <b-spinner v-if="savingTime" small type="grow" />
              <span v-else> {{ $t("Apply on Staff Profiles") }} </span>
            </b-button>
          </b-col>
        </b-row>
      </b-form>
      <sidebar-content />
    </b-sidebar>

    <b-sidebar
      id="sidebar-grace"
      ref="mySidebar"
      bg-variant="white"
      v-model="visibility3"
      sidebar-class="sidebar-lg"
      right
      no-header
      backdrop
      shadow
    >
      <div
        class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1"
      >
        <h5 class="mb-0">
          {{ currentDep && currentDep.name }} {{ $t("Grace Time") }}
        </h5>
        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="visibility3 = false"
        />
      </div>
      <b-form class="p-2" @submit.prevent>
        <b-row class="mt-1">
          <b-col md="12">
            <b-form-group
              :label="$t('Grace Time (minutes)')"
              :invalid-feedback="$t('Please enter valid number')"
              ref="grace"
            >
              <b-form-input
                type="number"
                v-model="graceTimeInput"
                :placeholder="$t('Enter grace time in minutes')"
              />
            </b-form-group>
          </b-col>

          <b-col md="12" class="mt-2">
            <b-button
              variant="success"
              block
              @click="applyGrace()"
              :disabled="applying"
            >
              <b-spinner v-if="applying" small type="grow" />
              <span v-else>{{ $t("Apply") }}</span>
            </b-button>
          </b-col>
        </b-row>
      </b-form>
      <sidebar-content />
    </b-sidebar>

    <b-sidebar
      id="sidebar-timing"
      bg-variant="white"
      v-model="visibility4"
      sidebar-class="sidebar-lg"
      right
      no-header
      backdrop
      shadow
      width="600px"
    >
      <div
        class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1"
      >
        <h5 class="mb-0">
          {{ currentDep ? currentDep.name : $t("Department") }}
          {{ $t("Timings") }}
          <b-form-checkbox
            class="mr-0 ml-1"
            v-model="sameDays"
            switch
            inline
            v-b-tooltip.hover.bottomright
            :title="$t('Everyday schedule same as monday')"
            @input="setDepDays(depTimings[0])"
          />
        </h5>
        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="visibility4 = false"
        />
      </div>
      <b-form class="px-1 py-2" @submit.prevent>
        <b-row v-if="depLoading">
          <b-col md="12" class="text-center my-3">
            <b-spinner type="grow" variant="primary" />
          </b-col>
        </b-row>
        <template v-else>
          <b-row v-for="(item, index) in depTimings" :key="index">
            <b-col md="4" class="pr-md-0">
              <b-form-group
                :invalid-feedback="$t('Day is required')"
                ref="d_day"
              >
                <div
                  class="d-flex align-items-center justify-content-between pb-50"
                >
                  <label class="bv-no-focus-ring col-form-label p-0"
                    >{{ $t("Day") }}
                  </label>
                  <b-form-checkbox
                    v-model="item.dayOff"
                    switch
                    inline
                    v-b-tooltip.hover.bottomright
                    :title="$t('Day Off')"
                    class="custom-control-danger mr-0 ml-1"
                  />
                </div>
                <v-select
                  v-model="item.day"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="daysList"
                  :reduce="(op) => op.value"
                  :selectable="(opt) => !depDays.includes(opt.value)"
                  :clearable="false"
                  label="text"
                  @input="changeDepDay()"
                />
              </b-form-group>
            </b-col>
            <b-col md="3" class="pr-md-0">
              <b-form-group
                :label="$t('Reporting Time')"
                :invalid-feedback="$t('Reporting Time is required')"
                ref="reportingTime"
              >
                <flat-pickr
                  v-model="item.reportingTime"
                  class="form-control"
                  :config="{
                    enableTime: true,
                    noCalendar: true,
                    altFormat: 'h:i K',
                    altInput: true,
                    dateFormat: 'Y-m-d\\TH:i:S',
                    defaultHour: 8,
                  }"
                  :disabled="item.dayOff"
                />
              </b-form-group>
            </b-col>
            <b-col md="2" class="pr-md-0">
              <b-form-group
                :label="$t('Grace Mins')"
                :invalid-feedback="$t('Grace Mins is required')"
                ref="graceMins"
              >
                <b-form-input
                  type="number"
                  v-model="item.graceMins"
                  :placeholder="$t('Enter grace time in minutes')"
                />
              </b-form-group>
            </b-col>
            <b-col md="3" class="">
              <b-form-group
                :label="$t('Leaves at')"
                :invalid-feedback="$t('Leaves at is required')"
              >
                <flat-pickr
                  v-model="item.timeOut"
                  class="form-control"
                  :config="{
                    enableTime: true,
                    noCalendar: true,
                    altFormat: 'h:i K',
                    altInput: true,
                    dateFormat: 'Y-m-d\\TH:i:S',
                    defaultHour: 13,
                  }"
                  :disabled="item.dayOff"
                  @on-close="setDepDays(item)"
                />
              </b-form-group>
            </b-col>

            <b-col md="12" class="pr-md-0 text-center mb-1">
              <b-button
                v-if="index == depTimings.length - 1 && depTimings.length < 7"
                variant="primary"
                class="btn-icon"
                pill
                @click="addDepDay()"
              >
                <feather-icon icon="PlusIcon" size="16" />
              </b-button>

              <b-button
                v-if="depTimings.length > 1"
                variant="outline-danger"
                class="btn-icon ml-1"
                pill
                @click="removeDepDay(item, index)"
              >
                <feather-icon icon="TrashIcon" size="16" />
              </b-button>
            </b-col>
          </b-row>
          <b-row class="mt-2">
            <b-col md="12">
              <b-button
                variant="success"
                @click="saveDepTimings(false)"
                :disabled="savingDep"
                block
              >
                <b-spinner v-if="savingDep && !syncing" small type="grow" />
                <span v-else> {{ $t("Save") }} </span>
              </b-button>
            </b-col>
            <b-col md="12" class="mt-2">
              <b-button
                variant="info"
                @click="saveDepTimings(true)"
                :disabled="savingDep"
                block
              >
                <b-spinner v-if="savingDep && syncing" small type="grow" />
                <span v-else> {{ $t("Save & Update Staff Profile") }} </span>
              </b-button>
            </b-col>
          </b-row>
        </template>
      </b-form>
      <sidebar-content />
    </b-sidebar>

    <b-card>
      <b-row class="mt-1">
        <b-col xl="2" lg="3" md="4" sm="12" cols="12" v-if="rights.add">
          <b-button
            @click="AddOpen()"
            block
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
          >
            <feather-icon icon="PlusIcon" class="mr-50" />
            <span class="align-middle">{{ $t("Add") }}</span>
          </b-button>
        </b-col>

        <b-col
          class="mt-lg-0 mt-md-0 mt-sm-1 mt-1"
          xl="10"
          lg="9"
          md="8"
          sm="12"
          cols="12"
        >
          <b-form-group class="">
            <b-input-group>
              <b-input-group-prepend is-text>
                <feather-icon icon="SearchIcon" />
              </b-input-group-prepend>

              <b-form-input
                v-model="searchQuery"
                :placeholder="$t('Search') + '...'"
              >
              </b-form-input>
            </b-input-group>
          </b-form-group>
        </b-col>
      </b-row>
      <b-col cols="12" class="d-flex align-items-center justify-content-center">
        <b-pagination
          v-model="currentPage"
          :total-rows="filters.length"
          :per-page="perPage"
          first-number
          last-number
          class="mb-0 mt-1 mt-sm-0"
          prev-class="prev-item"
          next-class="next-item"
        >
          <template #prev-text>
            <feather-icon icon="ChevronLeftIcon" size="18" />
          </template>
          <template #next-text>
            <feather-icon icon="ChevronRightIcon" size="18" />
          </template>
        </b-pagination>
      </b-col>
      <b-table
        class="mt-1"
        ref="selectableTable"
        :items="filters"
        :fields="fields"
        :current-page="currentPage"
        :per-page="perPage"
        :busy="dataLoading"
        show-empty
        responsive
        hover
        :selectable="rights.edit"
        select-mode="single"
        @row-selected="Edit($event[0].id)"
      >
        <template #empty="scope">
          <h3 class="mt-1 mb-1 text-center">{{ $t("No records found") }}</h3>
        </template>
        <template #table-busy>
          <div
            class="d-flex justify-content-center mb-3"
            style="margin-top: 50px"
          >
            <b-spinner
              style="width: 3rem; height: 3rem"
              type="grow"
              variant="primary"
              label="Spinning"
            ></b-spinner>
          </div>
        </template>

        <template #head()="scope">
          <div :class="scope.label == 'actions' && 'text-center'">
            {{ $t(scope.label) }}
          </div>
        </template>

        <template #cell(name)="data">
          <b-badge variant="light-primary">
            {{ data.item.name }}
          </b-badge>
        </template>

        <template #cell(actions)="data">
          <div class="text-center">
            <b-button
              v-if="rights.edit"
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              v-b-tooltip.hover.left
              :title="$t('Timings')"
              class="btn-icon mr-1"
              @click="
                [
                  'myskoolstanmore',
                  'myskooliuss',
                  'myskoolalhameed',
                  'myskoolstjacob',
                ].includes(reportDomain)
                  ? openDepTimings(data.item)
                  : openTimings(data.item)
              "
            >
              <feather-icon icon="CalendarIcon" />
            </b-button>
            <b-button
              v-if="rights.edit"
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="outline-primary"
              v-b-tooltip.hover.left
              :title="$t('Grace Time')"
              class="btn-icon mr-1"
              @click="openGrace(data.item)"
            >
              <feather-icon icon="ClockIcon" />
            </b-button>

            <b-button
              v-if="rights.edit"
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              v-b-tooltip.hover.left
              :title="$t('Edit')"
              class="btn-icon mr-1"
              @click="Edit(data.item.id)"
            >
              <feather-icon icon="EditIcon" />
            </b-button>

            <b-button
              v-if="rights.delete"
              v-ripple.400="'rgba(113, 102, 240, 0.15)'"
              variant="outline-danger"
              v-b-tooltip.hover.right
              :title="$t('Delete')"
              class="btn-icon"
              @click="Delete(data.item.id)"
            >
              <feather-icon icon="Trash2Icon" />
            </b-button>
          </div>
        </template>
      </b-table>
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BFormGroup,
  BForm,
  BSpinner,
  BSidebar,
  BInputGroupPrepend,
  BInputGroup,
  BFormCheckbox,
  VBTooltip,
  VBToggle,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import { mapActions, mapGetters } from "vuex";

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BFormGroup,
    BForm,
    BSpinner,
    BSidebar,
    BInputGroupPrepend,
    BInputGroup,
    BFormCheckbox,
    vSelect,
    flatPickr,
  },
  directives: {
    "b-tooltip": VBTooltip,
    "b-toggle": VBToggle,
    Ripple,
  },
  data() {
    return {
      rights: {},
      request: false,
      sidebarTitle: "Add Department",
      sidebarButton: "Save",
      dataLoading: false,
      visibility: false,
      logoloading: "",
      searchQuery: "",
      currentPage: 1,
      perPage: 30,
      fields: [
        { label: "Name", key: "name" },
        { key: "actions", label: "actions" },
      ],
      items: [],
      myObj: {
        id: 0,
        name: "",
        campusID: this.$store.state.userData.cId,
      },
      visibility2: false,
      sameDays: this.$store.state.sameTimings,
      daysList: [
        { text: "Monday", value: "monday" },
        { text: "Tuesday", value: "tuesday" },
        { text: "Wednesday", value: "wednesday" },
        { text: "Thursday", value: "thursday" },
        { text: "Friday", value: "friday" },
        { text: "Saturday", value: "saturday" },
        { text: "Sunday", value: "sunday" },
      ],
      currDays: [],
      timingInfo: [],
      savingTime: false,
      currentDep: null,
      visibility3: false,
      graceTimeInput: 0,
      applying: false,
      visibility4: false,
      depLoading: false,
      depTimings: [],
      depDays: [],
      savingDep: false,
      syncing: false,
      reportDomain: this.$store.state.report.replace(/_/g, ""),
      diffCampus: ["myskooliuss"], // same department but different campusIDs
      depCampusID: this.$store.state.userData.cId,
    };
  },
  computed: {
    filters: function () {
      return this.items.filter((pro) => {
        return pro.name.toLowerCase().match(this.searchQuery.toLowerCase());
      });
    },
  },
  async created() {
    if (!this.$store.state.rights[this.$route.name]) {
      this.$router.replace({
        name: "misc-not-authorized",
      });
    } else {
      this.rights = this.$store.state.rights[this.$route.name];
      this.LoadData();
    }
  },
  methods: {
    ...mapActions({ get: "get", post: "post", put: "put", delete: "delete" }),

    openDepTimings(item) {
      this.LoadTimings(item);
      this.currentDep = { ...item };
      this.visibility4 = true;
    },
    async LoadTimings(item) {
      this.depLoading = true;
      this.depCampusID = this.diffCampus.includes(this.reportDomain)
        ? this.$store.state.userData.cId
        : item.campusID;

      var obj = {
        url:
          this.$store.state.domain +
          "StaffDepartmentTimings/LoadData?db=" +
          this.$store.state.userData.db +
          "&cID=" +
          this.depCampusID +
          "&depID=" +
          item.id,
        token: this.$store.state.userData.token,
      };
      this.depTimings = await this.get(obj);
      this.depLoading = false;
      if (this.depTimings.length == 0) {
        this.depTimings.push({
          id: 0,
          departmentID: item.id,
          day: "monday",
          reportingTime: "2024-05-05T08:00:00",
          timeIn: "2024-05-05T08:00:00",
          timeOut: "2024-05-05T13:00:00",
          graceMins: 0,
          dayOff: false,
          campusID: this.depCampusID,
        });
      }
      this.changeDepDay();
    },
    changeDepDay() {
      this.depDays = this.depTimings.reduce((acc, el) => {
        acc.push(el.day);
        return acc;
      }, []);
    },
    setDepDays(item) {
      this.$store.commit("setSameTimings", this.sameDays);

      this.$nextTick(() => {
        // console.log(item.timeOut);
        if (
          this.depTimings.length == 1 &&
          this.sameDays &&
          item.day == "monday" &&
          item.reportingTime &&
          item.timeOut
        ) {
          // console.log(item);
          let days = ["tuesday", "wednesday", "thursday", "friday", "saturday"];
          let data = [item];
          days.forEach((el) => {
            data.push({
              id: 0,
              departmentID: this.currentDep.id,
              day: el,
              reportingTime: item.reportingTime,
              timeIn: item.reportingTime,
              timeOut: item.timeOut,
              graceMins: item.graceMins,
              dayOff: false,
              campusID: this.depCampusID,
            });
          });
          this.depTimings = data;
          this.changeDepDay();
        }
      });
    },
    addDepDay() {
      let t1 = "2024-05-05T08:00:00";
      let t2 = "2024-05-05T13:00:00";
      let mins = 0;
      let first = this.depTimings[0];
      if (first) {
        t1 = first.reportingTime ? first.reportingTime : "2024-05-05T08:00:00";
        t2 = first.timeOut ? first.timeOut : "2024-05-05T13:00:00";
        mins = first.graceMins ? first.graceMins : 0;
      }
      this.depTimings.push({
        id: 0,
        departmentID: this.currentDep.id,
        day: "",
        reportingTime: t1,
        timeIn: t1,
        timeOut: t2,
        graceMins: mins,
        dayOff: false,
        campusID: this.depCampusID,
      });
      // console.log(this.timingInfo);
    },
    removeDepDay(item, ind) {
      this.depTimings.splice(ind, 1);
      this.depDays = this.depDays.filter((el) => el != item.day);
    },
    CheckDepTimings() {
      let state = true;
      this.depTimings.forEach((el) => {
        let x = parseInt(el.graceMins);
        if (
          el.day == "" ||
          !el.reportingTime ||
          !el.timeOut ||
          isNaN(x) ||
          x < 0
        ) {
          state = false;
        } else {
          el.timeIn = el.reportingTime;
          el.graceMins = x;
        }
      });
      // console.log(state);
      return state;
    },
    async saveDepTimings(val) {
      if (this.CheckDepTimings() == true) {
        let result = { isConfirmed: true };
        if (val) {
          result = await Swal.fire({
            title: this.$t("Are you sure?"),
            text:
              "This will save the timings for all staff of " +
              this.currentDep.name,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
            confirmButtonText: this.$t("Yes"),
          });
        }
        // console.log(result);
        if (result.isConfirmed) {
          this.savingDep = true;
          this.syncing = val;

          // console.log(this.depTimings);

          var status = await this.post({
            url:
              this.$store.state.domain +
              "StaffDepartmentTimings/SaveData?db=" +
              this.$store.state.userData.db +
              "&cID=" +
              this.depCampusID +
              "&depID=" +
              this.currentDep.id +
              "&sync=" +
              val,
            body: this.depTimings,
            message: "Timings saved successfully!",
            context: this,
            token: this.$store.state.userData.token,
          });
          this.savingDep = false;
          this.syncing = false;
          if (status) {
            this.visibility4 = false;
          }
        }
      } else {
        this.$bvToast.toast(this.$t("Please enter the timings correctly!"), {
          title: this.$t("Error!"),
          variant: "danger",
          solid: true,
        });
      }
    },

    openGrace(item) {
      this.currentDep = { ...item };
      this.visibility3 = true;
      this.graceTimeInput = 0;
    },
    checkGrace() {
      var elem = this.$refs["grace"];
      let x = parseInt(this.graceTimeInput);
      if (isNaN(x) || x <= 0) {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    async applyGrace() {
      if (this.checkGrace() == false) {
        this.$bvToast.toast(
          this.$t("Grace time must be greater than 0 minutes"),
          {
            title: this.$t("Error!"),
            variant: "danger",
            toaster: "b-toaster-top-right",
          }
        );
      } else {
        let result = await Swal.fire({
          title: this.$t("Are you sure?"),
          text:
            "Do you want to update the Check-in time for all staff of " +
            this.currentDep.name +
            " by " +
            this.graceTimeInput +
            " minutes?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#d33",
          cancelButtonColor: "#3085d6",
          confirmButtonText: this.$t("Yes"),
        });
        if (result.isConfirmed) {
          this.applying = true;
          this.graceTimeInput = parseInt(this.graceTimeInput);

          var status = await this.post({
            url:
              this.$store.state.domain +
              "staff/ApplyGraceTimeByDep?db=" +
              this.$store.state.userData.db +
              "&depID=" +
              this.currentDep.id +
              "&mins=" +
              this.graceTimeInput,
            message: "Grace time applied successfully",
            context: this,
            token: this.$store.state.userData.token,
          });
          this.applying = false;
          if (status) {
            this.visibility3 = false;
          }
        }
      }
    },

    openTimings(item) {
      this.currentDep = { ...item };
      this.visibility2 = true;

      if (this.timingInfo.length == 0) {
        this.timingInfo = [
          {
            id: 0,
            tID: 0,
            day: "monday",
            timeIn: "2024-05-05T08:00:00",
            timeOut: "2024-05-05T13:00:00",
            dayOff: false,
            campusID: this.currentDep.campusID,
          },
        ];
      }
      this.changeDay();
    },
    changeDay() {
      this.currDays = this.timingInfo.reduce((acc, el) => {
        acc.push(el.day);
        return acc;
      }, []);
      // console.log(this.currDays);
    },
    setDays(item) {
      this.$store.commit("setSameTimings", this.sameDays);

      this.$nextTick(() => {
        // console.log(item.timeOut);
        if (
          this.timingInfo.length == 1 &&
          this.sameDays &&
          item.day == "monday" &&
          item.timeIn &&
          item.timeOut
        ) {
          // console.log(item);
          let days = ["tuesday", "wednesday", "thursday", "friday", "saturday"];
          let data = [item];
          days.forEach((el) => {
            data.push({
              id: 0,
              tID: 0,
              day: el,
              timeIn: item.timeIn,
              timeOut: item.timeOut,
              dayOff: false,
              campusID: item.campusID,
            });
          });
          this.timingInfo = data;
          this.changeDay();
        }
      });
    },
    addDay() {
      let t1 = "2024-05-05T08:00:00";
      let t2 = "2024-05-05T13:00:00";
      let first = this.timingInfo[0];
      if (first) {
        t1 = first.timeIn ? first.timeIn : "2024-05-05T08:00:00";
        t2 = first.timeOut ? first.timeOut : "2024-05-05T13:00:00";
      }
      this.timingInfo.push({
        id: 0,
        tID: 0,
        day: "",
        timeIn: t1,
        timeOut: t2,
        dayOff: false,
        campusID: this.currentDep.campusID,
      });
      // console.log(this.timingInfo);
    },
    removeDay(item, ind) {
      this.timingInfo.splice(ind, 1);
      this.currDays = this.currDays.filter((el) => el != item.day);
    },
    CheckTimings() {
      let state = true;
      this.timingInfo.forEach((el) => {
        if (el.day == "" || !el.timeIn || !el.timeOut) {
          state = false;
        }
      });
      // console.log(state);
      return state;
    },
    async saveTimings() {
      if (this.CheckTimings() == true) {
        let result = await Swal.fire({
          title: this.$t("Are you sure?"),
          text:
            "This will save the timings for all staff of " +
            this.currentDep.name,
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#d33",
          cancelButtonColor: "#3085d6",
          confirmButtonText: this.$t("Yes"),
        });
        if (result.isConfirmed) {
          this.savingTime = true;
          let obj = {
            tIDs: [],
            depID: this.currentDep.id,
            timings: this.timingInfo,
          };
          // console.log(obj);

          var status = await this.post({
            url:
              this.$store.state.domain +
              "staff/BulkTimings?db=" +
              this.$store.state.userData.db +
              "&cID=" +
              this.currentDep.campusID,
            body: obj,
            message: "Timings saved successfully!",
            context: this,
            token: this.$store.state.userData.token,
          });
          this.savingTime = false;
          if (status) {
            this.visibility2 = false;
          }
        }
      } else {
        this.$bvToast.toast(this.$t("Please enter the timings correctly!"), {
          title: this.$t("Error!"),
          variant: "danger",
          solid: true,
        });
      }
    },

    async Edit(id) {
      var obj = {
        url:
          this.$store.state.domain +
          "StaffDepartments/GetSelected?id=" +
          id +
          "&db=" +
          this.$store.state.userData.db,
        token: this.$store.state.userData.token,
      };
      this.myObj = await this.get(obj);
      // console.log("editObj:", this.myObj);
      this.visibility = true;
      this.sidebarTitle = "Edit Staff Department";
      this.sidebarButton = "Update";

      var elem = this.$refs["name"];
      elem.state = undefined;
    },

    AddOpen() {
      this.myObj = {
        id: 0,
        name: "",
        campusID: this.$store.state.userData.cId,
      };
      this.visibility = true;
      this.sidebarTitle = "Add Staff Department";
      this.sidebarButton = "Save";

      var elem = this.$refs["name"];
      elem.state = undefined;
    },

    CheckName() {
      var elem = this.$refs["name"];
      if (this.myObj.name == "" || this.myObj.name > 20) {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    hideSideBar() {
      this.visibility = false;
    },

    async LoadData() {
      this.dataLoading = true;
      var obj = {
        url:
          this.$store.state.domain +
          "StaffDepartments?db=" +
          this.$store.state.userData.db +
          "&cId=" +
          this.$store.state.userData.cId,
        token: this.$store.state.userData.token,
      };
      this.items = await this.get(obj);

      this.dataLoading = false;
      // console.log("staff dept", this.items);
    },

    async Add() {
      this.CheckName();
      if (this.CheckName() == false) {
        return this.$bvToast.toast(this.$t("Please fill the form correctly."), {
          title: this.$t("Error!"),
          variant: "danger",
          toaster: "b-toaster-top-center",
        });
      } else {
        if (this.myObj.id == 0) {
          //Add
          this.request = true;
          var status = await this.post({
            url:
              this.$store.state.domain +
              "StaffDepartments?db=" +
              this.$store.state.userData.db,
            body: this.myObj,
            message: "Department added successfully.",
            context: this,
            token: this.$store.state.userData.token,
          });
          this.request = false;
          this.visibility = false;
          if (status) this.LoadData();
        } else {
          //Edit
          this.request = true;
          var status = await this.put({
            url:
              this.$store.state.domain +
              "StaffDepartments/" +
              this.myObj.id +
              "?db=" +
              this.$store.state.userData.db,
            body: this.myObj,
            message: "department updated successfully.",
            context: this,
            token: this.$store.state.userData.token,
          });
          this.request = false;
          this.visibility = false;
          if (status) this.LoadData();
        }
      }
    },

    async Delete(id) {
      let result = await Swal.fire({
        title: this.$t("Are you sure?"),
        text: this.$t("You won't be able to revert this!"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        confirmButtonText: this.$t("Yes, Delete it!"),
      });
      if (result.isConfirmed) {
        var status = await this.delete({
          url:
            this.$store.state.domain +
            "StaffDepartments/" +
            id +
            "?db=" +
            this.$store.state.userData.db,
          body: null,
          message: "Staff Department removed successfully.",
          context: this,
          token: this.$store.state.userData.token,
        });
        if (status) this.LoadData();
      }
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>
<style scoped>
.card {
  transition: 0.4s;
}
.card:hover {
  box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2);
}
</style>
